import React, { FunctionComponent } from 'react';

import { HistoryStep } from 'scenes/common/components/Steps';
import { HomeFullPageProps } from 'scenes/home/types';
import { getHistoryDetails, hasBuildingCoverType } from 'scenes/home/selectors';
import { InsuredItem } from 'scenes/common/types';

export const QUESTION = `In the last 5 years, have you, any other policy holder or anyone else living at the ${InsuredItem.Home}`;

export const OccupantsHistoryStep: FunctionComponent<HomeFullPageProps> = ({
  funnelState,
  onNext,
  onUpdateToPolicyDetails,
}) => (
  <HistoryStep
    question={QUESTION}
    onNext={
      hasBuildingCoverType(funnelState) ? onNext : onUpdateToPolicyDetails
    }
    defaultStateValue={getHistoryDetails(funnelState)}
  />
);

export default OccupantsHistoryStep;
